import { jsx as _jsx } from "react/jsx-runtime";
import { DotsLoader, Loader } from '@brushfire/ui';
import { getFirestore, onSnapshot, doc, deleteDoc } from 'firebase/firestore';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { log, platformAwareRedirect } from '../../../data/helpers';
import { pubSubFb } from '../../../firebase';
import { setPageError } from '../../../store/AppState/actions';
var Tix = function (_a) {
    var isWidget = _a.isWidget;
    var orderId = useParams().orderId;
    var dispatch = useDispatch();
    var history = useHistory();
    var firestore = getFirestore(pubSubFb);
    useEffect(function () {
        try {
            var tixDoc_1 = doc(firestore, "tix/".concat(orderId));
            var unsubscribe_1 = onSnapshot(tixDoc_1, function (doc) {
                var data = doc.data();
                log("Tix Document Data: ".concat(JSON.stringify(data, null, 2)));
                if (data && data.Created && data.Route) {
                    // delete the document, unsubscribe, and redirect
                    deleteDoc(tixDoc_1);
                    unsubscribe_1();
                    platformAwareRedirect(data.Route, isWidget, history);
                }
            });
        }
        catch (error) {
            dispatch(setPageError({ error: "This order does not exist.", status: 404 }));
        }
    }, []);
    return (_jsx("div", { children: _jsx(Loader, { loadingText: ["Your order is currently being processed..."], loadingTextStyle: { color: "#dddddd" }, customLoadingIcon: _jsx(DotsLoader, { containerClasses: "global-loader-container" }), classes: "global-loader" }) }));
};
export default Tix;
